import React from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'
import MediaUpload from 'components/MediaUpload'
import ColorInput from 'components/ColorInput'

export default function ({ branding, project, onChange, disabled }) {
  return (
    <>
      <section>
        <Heading size='4'>Main Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />

        <Heading size='4'>Footer Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.footerLogo}
          heading='Drag and Drop'
          onUpload={onChange('footerLogo')}
          projectId={project?.meta?.id}
          path={'branding-footer-logo'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>

      <section>
        <Heading size='4'>Colors</Heading>
        <FormItem label='Primary Color'>
          <ColorInput
            placeholder='Primary Color'
            name='primaryColor'
            value={branding.primaryColor}
            onChange={onChange('primaryColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Background Color'>
          <ColorInput
            placeholder='Background Color'
            name='backgroundColor'
            value={branding.backgroundColor}
            onChange={onChange('backgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Primary Text Color'>
          <ColorInput
            placeholder='Primary Text Color'
            name='primaryTextColor'
            value={branding.primaryTextColor}
            onChange={onChange('primaryTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Header Text Color'>
          <ColorInput
            placeholder='Header Text Color'
            name='headerTextColor'
            value={branding.headerTextColor}
            onChange={onChange('headerTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Header Subtitle Text Color'>
          <ColorInput
            placeholder='Header Subtitle Text Color'
            name='headerSubTitlesColor'
            value={branding.headerSubTitlesColor}
            onChange={onChange('headerSubTitlesColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Main Navigation Background Color'>
          <ColorInput
            placeholder='Main Navigation Background Color'
            name='mainNavBackgroundColor'
            value={branding.mainNavBackgroundColor}
            onChange={onChange('mainNavBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Main Navigation Text Color'>
          <ColorInput
            placeholder='Main Navigation Text Color'
            name='mainNavTextColor'
            value={branding.mainNavTextColor}
            onChange={onChange('mainNavTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Main Navigation Highlight Color'>
          <ColorInput
            placeholder='Main Navigation Highlight Color'
            name='mainNavTextHighlightColor'
            value={branding.mainNavTextHighlightColor}
            onChange={onChange('mainNavTextHighlightColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Login Screen Background Color'>
          <ColorInput
            placeholder='Login Screen Background Color'
            name='loginScreenBackgroundColor'
            value={branding.loginScreenBackgroundColor}
            onChange={onChange('loginScreenBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Footer Text Color'>
          <ColorInput
            placeholder='Footer Text Color'
            name='footerTextColor'
            value={branding.footerTextColor}
            onChange={onChange('footerTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Footer Background Color'>
          <ColorInput
            placeholder='Footer Background Color'
            name='footerBackgroundColor'
            value={branding.footerBackgroundColor}
            onChange={onChange('footerBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
      </section>

      <section>
        <Heading size='4'>Fonts & Other</Heading>

        <FormItem label='Heading Font'>
          <Textfield
            placeholder='Heading Font'
            name='headingFont'
            value={branding.headingFont}
            onChange={onChange('headingFont')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Body Font'>
          <Textfield
            placeholder='Body Font'
            name='bodyFont'
            value={branding.bodyFont}
            onChange={onChange('bodyFont')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Button Border Radius'>
          <Textfield
            placeholder='Button Border Radius'
            name='buttonBorderRadius'
            value={branding.buttonBorderRadius}
            onChange={onChange('buttonBorderRadius')}
            disabled={disabled}
          />
        </FormItem>
      </section>
    </>
  )
}
